/* React */
import React from "react";

/* Utils */
import ChartWrapper from "src/utils/wrapper/chart-wrapper/ChartWrapper";
import { ResizeProvider } from "src/utils/provider/resize-provider/ResizeProvider";

/* Components */
import SankeyDiagram from "src/components/charts/sankey-diagram/SankeyDiagram";
import SankeyDiagramOptions from "src/components/chart-wrapper/toolbar/options/sankey-diagram-options/SankeyDiagramOptions";

/* Interfaces */
import { ChartType } from "src/shared/constants/charts/Chart";
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { TreatmentPatternsProps } from "src/shared/interfaces/TreatmentPatterns";
import { ComponentProps } from "src/shared/interfaces/common/Layout";

export const createSankeyDiagram = (
  outerIndex: number,
  label: React.ReactNode,
  data: BaseChartProps<
    TreatmentPatternsProps[],
    ChartType[][]
  >,
  downloadFilename?: string
): ComponentProps[] => {
  return [
    {
      component: (
        <ResizeProvider withResizer>
          <ChartWrapper
            label={label}
            options={<SankeyDiagramOptions />}
            downloadFilename={downloadFilename}
          >
            {(height, width) => (
              <SankeyDiagram
                key={`sankey-${outerIndex}`}
                data={data.data[outerIndex].sankey}
                originalData={
                  data.data[outerIndex].originalSankey
                }
                dimension={{ height, width }}
              />
            )}
          </ChartWrapper>
        </ResizeProvider>
      ),
      fullWidth: true,
    },
  ];
};
